import p0 from "./plugins/_api/badges";
import p1 from "./plugins/_api/chatButtons";
import p2 from "./plugins/_api/commands";
import p3 from "./plugins/_api/contextMenu";
import p4 from "./plugins/_api/dynamicImageModalApi";
import p5 from "./plugins/_api/memberListDecorators";
import p6 from "./plugins/_api/menuItemDemangler";
import p7 from "./plugins/_api/messageAccessories";
import p8 from "./plugins/_api/messageDecorations";
import p9 from "./plugins/_api/messageEvents";
import p10 from "./plugins/_api/messagePopover";
import p11 from "./plugins/_api/messageUpdater";
import p12 from "./plugins/_api/notices";
import p13 from "./plugins/_api/serverList";
import p14 from "./plugins/_api/userSettings";
import p15 from "./plugins/_core/noTrack";
import p16 from "./plugins/_core/settings";
import p17 from "./plugins/_core/supportHelper";
import p18 from "./plugins/accountPanelServerProfile";
import p19 from "./plugins/alwaysAnimate";
import p20 from "./plugins/alwaysExpandRoles";
import p21 from "./plugins/alwaysTrust";
import p22 from "./plugins/anonymiseFileNames";
import p23 from "./plugins/arRPC.web";
import p24 from "./plugins/betterFolders";
import p25 from "./plugins/betterGifAltText";
import p26 from "./plugins/betterGifPicker";
import p27 from "./plugins/betterNotes";
import p28 from "./plugins/betterRoleContext";
import p29 from "./plugins/betterRoleDot";
import p30 from "./plugins/betterSessions";
import p31 from "./plugins/betterSettings";
import p32 from "./plugins/betterUploadButton";
import p33 from "./plugins/biggerStreamPreview";
import p34 from "./plugins/blurNsfw";
import p35 from "./plugins/callTimer";
import p36 from "./plugins/clearURLs";
import p37 from "./plugins/clientTheme";
import p38 from "./plugins/colorSighted";
import p39 from "./plugins/consoleJanitor";
import p40 from "./plugins/consoleShortcuts";
import p41 from "./plugins/copyEmojiMarkdown";
import p42 from "./plugins/copyFileContents";
import p43 from "./plugins/copyStickerLinks";
import p44 from "./plugins/copyUserURLs";
import p45 from "./plugins/crashHandler";
import p46 from "./plugins/ctrlEnterSend";
import p47 from "./plugins/customIdle";
import p48 from "./plugins/customRPC";
import p49 from "./plugins/dearrow";
import p50 from "./plugins/decor";
import p51 from "./plugins/disableCallIdle";
import p52 from "./plugins/dontRoundMyTimestamps";
import p53 from "./plugins/experiments";
import p54 from "./plugins/expressionCloner";
import p55 from "./plugins/f8break";
import p56 from "./plugins/fakeNitro";
import p57 from "./plugins/fakeProfileThemes";
import p58 from "./plugins/favEmojiFirst";
import p59 from "./plugins/favGifSearch";
import p60 from "./plugins/fixCodeblockGap";
import p61 from "./plugins/fixImagesQuality";
import p62 from "./plugins/forceOwnerCrown";
import p63 from "./plugins/friendInvites";
import p64 from "./plugins/friendsSince";
import p65 from "./plugins/fullSearchContext";
import p66 from "./plugins/fullUserInChatbox";
import p67 from "./plugins/gameActivityToggle";
import p68 from "./plugins/gifPaste";
import p69 from "./plugins/greetStickerPicker";
import p70 from "./plugins/hideAttachments";
import p71 from "./plugins/iLoveSpam";
import p72 from "./plugins/ignoreActivities";
import p73 from "./plugins/imageFilename";
import p74 from "./plugins/imageLink";
import p75 from "./plugins/imageZoom";
import p76 from "./plugins/implicitRelationships";
import p77 from "./plugins/ircColors";
import p78 from "./plugins/keepCurrentChannel";
import p79 from "./plugins/lastfmRichPresence";
import p80 from "./plugins/loadingQuotes";
import p81 from "./plugins/memberCount";
import p82 from "./plugins/mentionAvatars";
import p83 from "./plugins/messageClickActions";
import p84 from "./plugins/messageLatency";
import p85 from "./plugins/messageLinkEmbeds";
import p86 from "./plugins/messageLogger";
import p87 from "./plugins/messageTags";
import p88 from "./plugins/mutualGroupDMs";
import p89 from "./plugins/newGuildSettings";
import p90 from "./plugins/noBlockedMessages";
import p91 from "./plugins/noDeepLinks.web";
import p92 from "./plugins/noDevtoolsWarning";
import p93 from "./plugins/noF1";
import p94 from "./plugins/noMaskedUrlPaste";
import p95 from "./plugins/noMosaic";
import p96 from "./plugins/noOnboardingDelay";
import p97 from "./plugins/noPendingCount";
import p98 from "./plugins/noProfileThemes";
import p99 from "./plugins/noReplyMention";
import p100 from "./plugins/noServerEmojis";
import p101 from "./plugins/noTypingAnimation";
import p102 from "./plugins/noUnblockToJump";
import p103 from "./plugins/normalizeMessageLinks";
import p104 from "./plugins/notificationVolume";
import p105 from "./plugins/onePingPerDM";
import p106 from "./plugins/oneko";
import p107 from "./plugins/openInApp";
import p108 from "./plugins/overrideForumDefaults";
import p109 from "./plugins/pauseInvitesForever";
import p110 from "./plugins/permissionFreeWill";
import p111 from "./plugins/permissionsViewer";
import p112 from "./plugins/petpet";
import p113 from "./plugins/pictureInPicture";
import p114 from "./plugins/pinDms";
import p115 from "./plugins/plainFolderIcon";
import p116 from "./plugins/platformIndicators";
import p117 from "./plugins/previewMessage";
import p118 from "./plugins/quickMention";
import p119 from "./plugins/quickReply";
import p120 from "./plugins/reactErrorDecoder";
import p121 from "./plugins/readAllNotificationsButton";
import p122 from "./plugins/relationshipNotifier";
import p123 from "./plugins/replaceGoogleSearch";
import p124 from "./plugins/replyTimestamp";
import p125 from "./plugins/revealAllSpoilers";
import p126 from "./plugins/reverseImageSearch";
import p127 from "./plugins/reviewDB";
import p128 from "./plugins/roleColorEverywhere";
import p129 from "./plugins/secretRingTone";
import p130 from "./plugins/seeSummaries";
import p131 from "./plugins/sendTimestamps";
import p132 from "./plugins/serverInfo";
import p133 from "./plugins/serverListIndicators";
import p134 from "./plugins/showAllMessageButtons";
import p135 from "./plugins/showConnections";
import p136 from "./plugins/showHiddenChannels";
import p137 from "./plugins/showHiddenThings";
import p138 from "./plugins/showMeYourName";
import p139 from "./plugins/showTimeoutDuration";
import p140 from "./plugins/silentMessageToggle";
import p141 from "./plugins/silentTyping";
import p142 from "./plugins/sortFriendRequests";
import p143 from "./plugins/spotifyControls";
import p144 from "./plugins/spotifyCrack";
import p145 from "./plugins/spotifyShareCommands";
import p146 from "./plugins/startupTimings";
import p147 from "./plugins/stickerPaste";
import p148 from "./plugins/streamerModeOnStream";
import p149 from "./plugins/superReactionTweaks";
import p150 from "./plugins/textReplace";
import p151 from "./plugins/themeAttributes";
import p152 from "./plugins/translate";
import p153 from "./plugins/typingIndicator";
import p154 from "./plugins/typingTweaks";
import p155 from "./plugins/unindent";
import p156 from "./plugins/unlockedAvatarZoom";
import p157 from "./plugins/unsuppressEmbeds";
import p158 from "./plugins/userMessagesPronouns";
import p159 from "./plugins/userVoiceShow";
import p160 from "./plugins/usrbg";
import p161 from "./plugins/validReply";
import p162 from "./plugins/validUser";
import p163 from "./plugins/vcDoubleClick";
import p164 from "./plugins/vcNarrator";
import p165 from "./plugins/vencordToolbox";
import p166 from "./plugins/viewIcons";
import p167 from "./plugins/viewRaw";
import p168 from "./plugins/voiceDownload";
import p169 from "./plugins/voiceMessages";
import p170 from "./plugins/volumeBooster";
import p171 from "./plugins/webContextMenus.web";
import p172 from "./plugins/webKeybinds.web";
import p173 from "./plugins/webScreenShareFixes.web";
import p174 from "./plugins/whoReacted";
import p175 from "./plugins/xsOverlay";
export default {
[p0.name]:p0,
[p1.name]:p1,
[p2.name]:p2,
[p3.name]:p3,
[p4.name]:p4,
[p5.name]:p5,
[p6.name]:p6,
[p7.name]:p7,
[p8.name]:p8,
[p9.name]:p9,
[p10.name]:p10,
[p11.name]:p11,
[p12.name]:p12,
[p13.name]:p13,
[p14.name]:p14,
[p15.name]:p15,
[p16.name]:p16,
[p17.name]:p17,
[p18.name]:p18,
[p19.name]:p19,
[p20.name]:p20,
[p21.name]:p21,
[p22.name]:p22,
[p23.name]:p23,
[p24.name]:p24,
[p25.name]:p25,
[p26.name]:p26,
[p27.name]:p27,
[p28.name]:p28,
[p29.name]:p29,
[p30.name]:p30,
[p31.name]:p31,
[p32.name]:p32,
[p33.name]:p33,
[p34.name]:p34,
[p35.name]:p35,
[p36.name]:p36,
[p37.name]:p37,
[p38.name]:p38,
[p39.name]:p39,
[p40.name]:p40,
[p41.name]:p41,
[p42.name]:p42,
[p43.name]:p43,
[p44.name]:p44,
[p45.name]:p45,
[p46.name]:p46,
[p47.name]:p47,
[p48.name]:p48,
[p49.name]:p49,
[p50.name]:p50,
[p51.name]:p51,
[p52.name]:p52,
[p53.name]:p53,
[p54.name]:p54,
[p55.name]:p55,
[p56.name]:p56,
[p57.name]:p57,
[p58.name]:p58,
[p59.name]:p59,
[p60.name]:p60,
[p61.name]:p61,
[p62.name]:p62,
[p63.name]:p63,
[p64.name]:p64,
[p65.name]:p65,
[p66.name]:p66,
[p67.name]:p67,
[p68.name]:p68,
[p69.name]:p69,
[p70.name]:p70,
[p71.name]:p71,
[p72.name]:p72,
[p73.name]:p73,
[p74.name]:p74,
[p75.name]:p75,
[p76.name]:p76,
[p77.name]:p77,
[p78.name]:p78,
[p79.name]:p79,
[p80.name]:p80,
[p81.name]:p81,
[p82.name]:p82,
[p83.name]:p83,
[p84.name]:p84,
[p85.name]:p85,
[p86.name]:p86,
[p87.name]:p87,
[p88.name]:p88,
[p89.name]:p89,
[p90.name]:p90,
[p91.name]:p91,
[p92.name]:p92,
[p93.name]:p93,
[p94.name]:p94,
[p95.name]:p95,
[p96.name]:p96,
[p97.name]:p97,
[p98.name]:p98,
[p99.name]:p99,
[p100.name]:p100,
[p101.name]:p101,
[p102.name]:p102,
[p103.name]:p103,
[p104.name]:p104,
[p105.name]:p105,
[p106.name]:p106,
[p107.name]:p107,
[p108.name]:p108,
[p109.name]:p109,
[p110.name]:p110,
[p111.name]:p111,
[p112.name]:p112,
[p113.name]:p113,
[p114.name]:p114,
[p115.name]:p115,
[p116.name]:p116,
[p117.name]:p117,
[p118.name]:p118,
[p119.name]:p119,
[p120.name]:p120,
[p121.name]:p121,
[p122.name]:p122,
[p123.name]:p123,
[p124.name]:p124,
[p125.name]:p125,
[p126.name]:p126,
[p127.name]:p127,
[p128.name]:p128,
[p129.name]:p129,
[p130.name]:p130,
[p131.name]:p131,
[p132.name]:p132,
[p133.name]:p133,
[p134.name]:p134,
[p135.name]:p135,
[p136.name]:p136,
[p137.name]:p137,
[p138.name]:p138,
[p139.name]:p139,
[p140.name]:p140,
[p141.name]:p141,
[p142.name]:p142,
[p143.name]:p143,
[p144.name]:p144,
[p145.name]:p145,
[p146.name]:p146,
[p147.name]:p147,
[p148.name]:p148,
[p149.name]:p149,
[p150.name]:p150,
[p151.name]:p151,
[p152.name]:p152,
[p153.name]:p153,
[p154.name]:p154,
[p155.name]:p155,
[p156.name]:p156,
[p157.name]:p157,
[p158.name]:p158,
[p159.name]:p159,
[p160.name]:p160,
[p161.name]:p161,
[p162.name]:p162,
[p163.name]:p163,
[p164.name]:p164,
[p165.name]:p165,
[p166.name]:p166,
[p167.name]:p167,
[p168.name]:p168,
[p169.name]:p169,
[p170.name]:p170,
[p171.name]:p171,
[p172.name]:p172,
[p173.name]:p173,
[p174.name]:p174,
[p175.name]:p175,
};export const PluginMeta={
[p0.name]:{"folderName":"_api/badges","userPlugin":false},
[p1.name]:{"folderName":"_api/chatButtons.ts","userPlugin":false},
[p2.name]:{"folderName":"_api/commands.ts","userPlugin":false},
[p3.name]:{"folderName":"_api/contextMenu.ts","userPlugin":false},
[p4.name]:{"folderName":"_api/dynamicImageModalApi.ts","userPlugin":false},
[p5.name]:{"folderName":"_api/memberListDecorators","userPlugin":false},
[p6.name]:{"folderName":"_api/menuItemDemangler.ts","userPlugin":false},
[p7.name]:{"folderName":"_api/messageAccessories.ts","userPlugin":false},
[p8.name]:{"folderName":"_api/messageDecorations","userPlugin":false},
[p9.name]:{"folderName":"_api/messageEvents.ts","userPlugin":false},
[p10.name]:{"folderName":"_api/messagePopover.ts","userPlugin":false},
[p11.name]:{"folderName":"_api/messageUpdater.ts","userPlugin":false},
[p12.name]:{"folderName":"_api/notices.ts","userPlugin":false},
[p13.name]:{"folderName":"_api/serverList.ts","userPlugin":false},
[p14.name]:{"folderName":"_api/userSettings.ts","userPlugin":false},
[p15.name]:{"folderName":"_core/noTrack.ts","userPlugin":false},
[p16.name]:{"folderName":"_core/settings.tsx","userPlugin":false},
[p17.name]:{"folderName":"_core/supportHelper.tsx","userPlugin":false},
[p18.name]:{"folderName":"accountPanelServerProfile","userPlugin":false},
[p19.name]:{"folderName":"alwaysAnimate","userPlugin":false},
[p20.name]:{"folderName":"alwaysExpandRoles","userPlugin":false},
[p21.name]:{"folderName":"alwaysTrust","userPlugin":false},
[p22.name]:{"folderName":"anonymiseFileNames","userPlugin":false},
[p23.name]:{"folderName":"arRPC.web","userPlugin":false},
[p24.name]:{"folderName":"betterFolders","userPlugin":false},
[p25.name]:{"folderName":"betterGifAltText","userPlugin":false},
[p26.name]:{"folderName":"betterGifPicker","userPlugin":false},
[p27.name]:{"folderName":"betterNotes","userPlugin":false},
[p28.name]:{"folderName":"betterRoleContext","userPlugin":false},
[p29.name]:{"folderName":"betterRoleDot","userPlugin":false},
[p30.name]:{"folderName":"betterSessions","userPlugin":false},
[p31.name]:{"folderName":"betterSettings","userPlugin":false},
[p32.name]:{"folderName":"betterUploadButton","userPlugin":false},
[p33.name]:{"folderName":"biggerStreamPreview","userPlugin":false},
[p34.name]:{"folderName":"blurNsfw","userPlugin":false},
[p35.name]:{"folderName":"callTimer","userPlugin":false},
[p36.name]:{"folderName":"clearURLs","userPlugin":false},
[p37.name]:{"folderName":"clientTheme","userPlugin":false},
[p38.name]:{"folderName":"colorSighted","userPlugin":false},
[p39.name]:{"folderName":"consoleJanitor","userPlugin":false},
[p40.name]:{"folderName":"consoleShortcuts","userPlugin":false},
[p41.name]:{"folderName":"copyEmojiMarkdown","userPlugin":false},
[p42.name]:{"folderName":"copyFileContents","userPlugin":false},
[p43.name]:{"folderName":"copyStickerLinks","userPlugin":false},
[p44.name]:{"folderName":"copyUserURLs","userPlugin":false},
[p45.name]:{"folderName":"crashHandler","userPlugin":false},
[p46.name]:{"folderName":"ctrlEnterSend","userPlugin":false},
[p47.name]:{"folderName":"customIdle","userPlugin":false},
[p48.name]:{"folderName":"customRPC","userPlugin":false},
[p49.name]:{"folderName":"dearrow","userPlugin":false},
[p50.name]:{"folderName":"decor","userPlugin":false},
[p51.name]:{"folderName":"disableCallIdle","userPlugin":false},
[p52.name]:{"folderName":"dontRoundMyTimestamps","userPlugin":false},
[p53.name]:{"folderName":"experiments","userPlugin":false},
[p54.name]:{"folderName":"expressionCloner","userPlugin":false},
[p55.name]:{"folderName":"f8break","userPlugin":false},
[p56.name]:{"folderName":"fakeNitro","userPlugin":false},
[p57.name]:{"folderName":"fakeProfileThemes","userPlugin":false},
[p58.name]:{"folderName":"favEmojiFirst","userPlugin":false},
[p59.name]:{"folderName":"favGifSearch","userPlugin":false},
[p60.name]:{"folderName":"fixCodeblockGap","userPlugin":false},
[p61.name]:{"folderName":"fixImagesQuality","userPlugin":false},
[p62.name]:{"folderName":"forceOwnerCrown","userPlugin":false},
[p63.name]:{"folderName":"friendInvites","userPlugin":false},
[p64.name]:{"folderName":"friendsSince","userPlugin":false},
[p65.name]:{"folderName":"fullSearchContext","userPlugin":false},
[p66.name]:{"folderName":"fullUserInChatbox","userPlugin":false},
[p67.name]:{"folderName":"gameActivityToggle","userPlugin":false},
[p68.name]:{"folderName":"gifPaste","userPlugin":false},
[p69.name]:{"folderName":"greetStickerPicker","userPlugin":false},
[p70.name]:{"folderName":"hideAttachments","userPlugin":false},
[p71.name]:{"folderName":"iLoveSpam","userPlugin":false},
[p72.name]:{"folderName":"ignoreActivities","userPlugin":false},
[p73.name]:{"folderName":"imageFilename","userPlugin":false},
[p74.name]:{"folderName":"imageLink","userPlugin":false},
[p75.name]:{"folderName":"imageZoom","userPlugin":false},
[p76.name]:{"folderName":"implicitRelationships","userPlugin":false},
[p77.name]:{"folderName":"ircColors","userPlugin":false},
[p78.name]:{"folderName":"keepCurrentChannel","userPlugin":false},
[p79.name]:{"folderName":"lastfmRichPresence","userPlugin":false},
[p80.name]:{"folderName":"loadingQuotes","userPlugin":false},
[p81.name]:{"folderName":"memberCount","userPlugin":false},
[p82.name]:{"folderName":"mentionAvatars","userPlugin":false},
[p83.name]:{"folderName":"messageClickActions","userPlugin":false},
[p84.name]:{"folderName":"messageLatency","userPlugin":false},
[p85.name]:{"folderName":"messageLinkEmbeds","userPlugin":false},
[p86.name]:{"folderName":"messageLogger","userPlugin":false},
[p87.name]:{"folderName":"messageTags","userPlugin":false},
[p88.name]:{"folderName":"mutualGroupDMs","userPlugin":false},
[p89.name]:{"folderName":"newGuildSettings","userPlugin":false},
[p90.name]:{"folderName":"noBlockedMessages","userPlugin":false},
[p91.name]:{"folderName":"noDeepLinks.web","userPlugin":false},
[p92.name]:{"folderName":"noDevtoolsWarning","userPlugin":false},
[p93.name]:{"folderName":"noF1","userPlugin":false},
[p94.name]:{"folderName":"noMaskedUrlPaste","userPlugin":false},
[p95.name]:{"folderName":"noMosaic","userPlugin":false},
[p96.name]:{"folderName":"noOnboardingDelay","userPlugin":false},
[p97.name]:{"folderName":"noPendingCount","userPlugin":false},
[p98.name]:{"folderName":"noProfileThemes","userPlugin":false},
[p99.name]:{"folderName":"noReplyMention","userPlugin":false},
[p100.name]:{"folderName":"noServerEmojis","userPlugin":false},
[p101.name]:{"folderName":"noTypingAnimation","userPlugin":false},
[p102.name]:{"folderName":"noUnblockToJump","userPlugin":false},
[p103.name]:{"folderName":"normalizeMessageLinks","userPlugin":false},
[p104.name]:{"folderName":"notificationVolume","userPlugin":false},
[p105.name]:{"folderName":"onePingPerDM","userPlugin":false},
[p106.name]:{"folderName":"oneko","userPlugin":false},
[p107.name]:{"folderName":"openInApp","userPlugin":false},
[p108.name]:{"folderName":"overrideForumDefaults","userPlugin":false},
[p109.name]:{"folderName":"pauseInvitesForever","userPlugin":false},
[p110.name]:{"folderName":"permissionFreeWill","userPlugin":false},
[p111.name]:{"folderName":"permissionsViewer","userPlugin":false},
[p112.name]:{"folderName":"petpet","userPlugin":false},
[p113.name]:{"folderName":"pictureInPicture","userPlugin":false},
[p114.name]:{"folderName":"pinDms","userPlugin":false},
[p115.name]:{"folderName":"plainFolderIcon","userPlugin":false},
[p116.name]:{"folderName":"platformIndicators","userPlugin":false},
[p117.name]:{"folderName":"previewMessage","userPlugin":false},
[p118.name]:{"folderName":"quickMention","userPlugin":false},
[p119.name]:{"folderName":"quickReply","userPlugin":false},
[p120.name]:{"folderName":"reactErrorDecoder","userPlugin":false},
[p121.name]:{"folderName":"readAllNotificationsButton","userPlugin":false},
[p122.name]:{"folderName":"relationshipNotifier","userPlugin":false},
[p123.name]:{"folderName":"replaceGoogleSearch","userPlugin":false},
[p124.name]:{"folderName":"replyTimestamp","userPlugin":false},
[p125.name]:{"folderName":"revealAllSpoilers","userPlugin":false},
[p126.name]:{"folderName":"reverseImageSearch","userPlugin":false},
[p127.name]:{"folderName":"reviewDB","userPlugin":false},
[p128.name]:{"folderName":"roleColorEverywhere","userPlugin":false},
[p129.name]:{"folderName":"secretRingTone","userPlugin":false},
[p130.name]:{"folderName":"seeSummaries","userPlugin":false},
[p131.name]:{"folderName":"sendTimestamps","userPlugin":false},
[p132.name]:{"folderName":"serverInfo","userPlugin":false},
[p133.name]:{"folderName":"serverListIndicators","userPlugin":false},
[p134.name]:{"folderName":"showAllMessageButtons","userPlugin":false},
[p135.name]:{"folderName":"showConnections","userPlugin":false},
[p136.name]:{"folderName":"showHiddenChannels","userPlugin":false},
[p137.name]:{"folderName":"showHiddenThings","userPlugin":false},
[p138.name]:{"folderName":"showMeYourName","userPlugin":false},
[p139.name]:{"folderName":"showTimeoutDuration","userPlugin":false},
[p140.name]:{"folderName":"silentMessageToggle","userPlugin":false},
[p141.name]:{"folderName":"silentTyping","userPlugin":false},
[p142.name]:{"folderName":"sortFriendRequests","userPlugin":false},
[p143.name]:{"folderName":"spotifyControls","userPlugin":false},
[p144.name]:{"folderName":"spotifyCrack","userPlugin":false},
[p145.name]:{"folderName":"spotifyShareCommands","userPlugin":false},
[p146.name]:{"folderName":"startupTimings","userPlugin":false},
[p147.name]:{"folderName":"stickerPaste","userPlugin":false},
[p148.name]:{"folderName":"streamerModeOnStream","userPlugin":false},
[p149.name]:{"folderName":"superReactionTweaks","userPlugin":false},
[p150.name]:{"folderName":"textReplace","userPlugin":false},
[p151.name]:{"folderName":"themeAttributes","userPlugin":false},
[p152.name]:{"folderName":"translate","userPlugin":false},
[p153.name]:{"folderName":"typingIndicator","userPlugin":false},
[p154.name]:{"folderName":"typingTweaks","userPlugin":false},
[p155.name]:{"folderName":"unindent","userPlugin":false},
[p156.name]:{"folderName":"unlockedAvatarZoom","userPlugin":false},
[p157.name]:{"folderName":"unsuppressEmbeds","userPlugin":false},
[p158.name]:{"folderName":"userMessagesPronouns","userPlugin":false},
[p159.name]:{"folderName":"userVoiceShow","userPlugin":false},
[p160.name]:{"folderName":"usrbg","userPlugin":false},
[p161.name]:{"folderName":"validReply","userPlugin":false},
[p162.name]:{"folderName":"validUser","userPlugin":false},
[p163.name]:{"folderName":"vcDoubleClick","userPlugin":false},
[p164.name]:{"folderName":"vcNarrator","userPlugin":false},
[p165.name]:{"folderName":"vencordToolbox","userPlugin":false},
[p166.name]:{"folderName":"viewIcons","userPlugin":false},
[p167.name]:{"folderName":"viewRaw","userPlugin":false},
[p168.name]:{"folderName":"voiceDownload","userPlugin":false},
[p169.name]:{"folderName":"voiceMessages","userPlugin":false},
[p170.name]:{"folderName":"volumeBooster","userPlugin":false},
[p171.name]:{"folderName":"webContextMenus.web","userPlugin":false},
[p172.name]:{"folderName":"webKeybinds.web","userPlugin":false},
[p173.name]:{"folderName":"webScreenShareFixes.web","userPlugin":false},
[p174.name]:{"folderName":"whoReacted","userPlugin":false},
[p175.name]:{"folderName":"xsOverlay","userPlugin":false},
};export const ExcludedPlugins={
"AppleMusicRichPresence":"desktop",
"DevCompanion":"dev",
"FixSpotifyEmbeds":"desktop",
"FixYoutubeEmbeds":"desktop",
"InvisibleChat":"desktop",
"NoSystemBadge":"discordDesktop",
"ShikiCodeblocks":"desktop",
"YoutubeAdblock":"desktop",
};